// Stałe dla systemu sprzedaży

// Źródła sprzedaży
export const SALE_SOURCES = {
  warehouse: 'Magazyn',
  order: 'Zamówienie',
  manual: 'Ręcznie'
};

// Statusy płatności
export const PAYMENT_STATUSES = {
  pending_payment: 'Oczekuje na płatność',
  deposit_paid: 'Zadatek wpłacony',
  full_payment: 'Pełna płatność',
  refunded: 'Zwrócono'
};

// Statusy dostawy
export const DELIVERY_STATUSES = {
  pending_delivery: 'Oczekuje na dostawę',
  shipped: 'Wysłano',
  delivered: 'Dostarczono',
  picked_up: 'Odebrano w sklepie'
};

// Statusy zadatku
export const DEPOSIT_STATUSES = {
  pending: 'Oczekuje',
  paid: 'Wpłacony',
  refunded: 'Zwrócony'
};

// Funkcje pomocnicze
export const getSourceLabel = (sourceKey) => {
  return SALE_SOURCES[sourceKey] || sourceKey;
};

export const getPaymentStatusLabel = (statusKey) => {
  return PAYMENT_STATUSES[statusKey] || statusKey;
};

export const getDeliveryStatusLabel = (statusKey) => {
  return DELIVERY_STATUSES[statusKey] || statusKey;
};

export const getDepositStatusLabel = (statusKey) => {
  return DEPOSIT_STATUSES[statusKey] || statusKey;
};

// Kolory statusów
export const getPaymentStatusColor = (status) => {
  switch (status) {
    case 'pending_payment':
      return 'warning';
    case 'deposit_paid':
      return 'info';
    case 'full_payment':
      return 'success';
    case 'refunded':
      return 'error';
    default:
      return 'default';
  }
};

export const getDeliveryStatusColor = (status) => {
  switch (status) {
    case 'pending_delivery':
      return 'warning';
    case 'shipped':
      return 'info';
    case 'delivered':
      return 'success';
    case 'picked_up':
      return 'success';
    default:
      return 'default';
  }
};

export const getDepositStatusColor = (status) => {
  switch (status) {
    case 'pending':
      return 'warning';
    case 'paid':
      return 'success';
    case 'refunded':
      return 'error';
    default:
      return 'default';
  }
};
